export const iconMapping = {
    'system-add': 'add-circle',
    'system-audio-off': 'audio-volume',
    'system-audio-on': 'audio-volume-off',
    'system-cancel': 'cancel',
    'system-code': 'code',
    'system-compare': 'compare',
    'system-download': 'download',
    'system-facebook': 'Facebook',
    'system-favorites': 'favorite',
    'system-follow': 'follow',
    'system-google-plus': 'google-plus',
    'system-help': 'help-circle',
    'system-info': 'info-circle',
    'system-instagram': 'instagram',
    'system-line-me': 'line-me',
    'system-linkedin': 'linkedin',
    'system-paragraph': 'paragraph-circle',
    'system-pause': 'pause',
    'system-pinterest': 'pinterest',
    'system-play': 'play',
    'system-play-backwards': undefined,
    'system-print': 'print',
    'system-remove': 'remove',
    'system-replay': 'replay',
    'system-resize-decrease': 'resize-decrease',
    'system-resize-increase': 'resize-increase',
    'system-save-as': 'download',
    'system-search': 'search',
    'system-select': 'select-circle',
    'system-settings': 'settings',
    'system-share': 'share',
    'system-share-android': 'share-android',
    'system-skip-next': 'skip-next',
    'system-skip-previous': 'skip-previous',
    'system-snapchat': 'snapchat',
    'system-sync': 'sync',
    'system-twitter': 'twitter',
    'system-upload': 'upload',
    'system-vimeo': 'vimeo',
    'system-wechat': 'wechat',
    'system-weibo': 'weibo',
    'system-whatsapp': 'whatsapp',
    'system-xing': 'xing',
    'system-yelp': 'yelp',
    'system-youku': 'youku',
    'system-youtube': 'youtube',
    'system-zhihu': 'zhihu',
    'poi-on-map': 'poi-active',
    'favorite-filled': 'favorite-active',
    'rating-filled': 'rating-active',
    twitter: 'x',
};
//# sourceMappingURL=iconMapping.mjs.mjs.map